export const AuthCardBanner = () => {
  return (
    <div className="bg-gradient-to-b from-[#fb8a3e] to-[#fd9c5b] h-full w-5/12 rounded-md p-6 flex flex-col justify-between">
      <div className="bg-[#fcfcf7] rounded-xl p-3 text-sm">
        <span className="font-playfair">
          PromptSlate has helped us to accelerate our AI offerings with its easy prompt management
          and versioning capabilities. We now deploy AI changes in seconds.
        </span>
        <div className="flex flex-row">
          <img
            src="/images/testimonial_01.png"
            alt="Client user photo"
            className="w-8 h-8 object-contain mt-3 rounded-md"
          />
          <div className="flex flex-col mt-3 pl-2">
            <span className="text-xs">John Miller</span>
            <span className="text-xs text-[#606060]">CTO, Caspry</span>
          </div>
        </div>
      </div>
      <img
        src="/logo_white.png"
        alt="PromptSlate logo"
        className="w-1/2 object-contain self-center rounded-md"
      />
    </div>
  );
};
